var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_383_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 40L6.53125 30.7539C4.97031 28.0539 4.15469 24.9813 4.15469 21.8383C4.15469 12.0016 12.1633 4 22 4C26.7742 4 31.2531 5.86328 34.6211 9.23125C37.9891 12.6062 39.8453 17.0852 39.8453 21.8523C39.8383 31.6891 31.8367 39.6906 22 39.6906H21.993C19.0047 39.6906 16.0727 38.9383 13.4641 37.518L4 40ZM13.9 34.2906L14.4414 34.6141C16.7195 35.9641 19.3281 36.6812 21.993 36.6812H22C30.1773 36.6812 36.8289 30.0297 36.8289 21.8523C36.8289 17.8937 35.2891 14.1672 32.4906 11.3617C29.6922 8.55625 25.9656 7.01641 22.007 7.01641C13.8227 7.01641 7.17109 13.668 7.17109 21.8453C7.17109 24.6437 7.95156 27.3719 9.43516 29.7344L9.78672 30.2969L8.28906 35.7672L13.9 34.2906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62598 39.3744L7.07285 30.4518C5.56113 27.8432 4.7666 24.876 4.7666 21.8455C4.77363 12.3463 12.501 4.62598 21.9932 4.62598C26.5986 4.62598 30.9299 6.41895 34.1783 9.67441C37.4338 12.9299 39.2268 17.2541 39.2197 21.8596C39.2127 31.3518 31.4854 39.0791 21.9932 39.0791H21.9861C19.1033 39.0791 16.2697 38.3549 13.7525 36.9838L4.62598 39.3744Z",
    fill: "url(#paint0_linear_383_93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 40L6.53125 30.7539C4.97031 28.0539 4.15469 24.9813 4.15469 21.8383C4.15469 12.0016 12.1633 4 22 4C26.7742 4 31.2531 5.86328 34.6211 9.23125C37.9891 12.6062 39.8453 17.0852 39.8453 21.8523C39.8383 31.6891 31.8367 39.6906 22 39.6906H21.993C19.0047 39.6906 16.0727 38.9383 13.4641 37.518L4 40ZM13.9 34.2906L14.4414 34.6141C16.7195 35.9641 19.3281 36.6812 21.993 36.6812H22C30.1773 36.6812 36.8289 30.0297 36.8289 21.8523C36.8289 17.8937 35.2891 14.1672 32.4906 11.3617C29.6922 8.55625 25.9656 7.01641 22.007 7.01641C13.8227 7.01641 7.17109 13.668 7.17109 21.8453C7.17109 24.6437 7.95156 27.3719 9.43516 29.7344L9.78672 30.2969L8.28906 35.7672L13.9 34.2906Z",
    fill: "url(#paint1_linear_383_93)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5354 14.3779C17.1979 13.6326 16.8463 13.6186 16.5299 13.6045C16.2697 13.5904 15.9744 13.5975 15.6721 13.5975C15.3768 13.5975 14.8916 13.71 14.4838 14.1529C14.076 14.5959 12.9229 15.6787 12.9229 17.8725C12.9229 20.0662 14.5189 22.1896 14.7439 22.485C14.9689 22.7803 17.8307 27.4279 22.3588 29.2139C26.1275 30.6975 26.8939 30.4021 27.7096 30.3318C28.5252 30.2615 30.3463 29.2561 30.7189 28.2154C31.0916 27.1748 31.0916 26.2818 30.9791 26.099C30.8666 25.9162 30.5713 25.8037 30.1213 25.5787C29.6783 25.3537 27.4846 24.2779 27.0768 24.1303C26.6689 23.9826 26.3736 23.9053 26.0713 24.3553C25.776 24.7982 24.9182 25.8037 24.658 26.099C24.3979 26.3943 24.1377 26.4365 23.6947 26.2115C23.2518 25.9865 21.8104 25.5154 20.1088 23.9967C18.7799 22.8154 17.8869 21.3529 17.6268 20.91C17.3666 20.467 17.5986 20.2209 17.8236 20.0029C18.0205 19.8061 18.2666 19.4826 18.4916 19.2225C18.7166 18.9623 18.7869 18.7795 18.9346 18.4771C19.0822 18.1818 19.0119 17.9217 18.8994 17.6967C18.801 17.4646 17.9361 15.2639 17.5354 14.3779Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_383_93",
    x: 0,
    y: 0,
    width: 43.8452,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_383_93"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_383_93",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_93",
    x1: 21.9227,
    y1: 39.3773,
    x2: 21.9227,
    y2: 4.62359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_383_93",
    x1: 21.9227,
    y1: 40,
    x2: 21.9227,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.929f7125615e117bb4f6961d25950cdf.svg";
export { ForwardRef as ReactComponent };